import ExportsService from '@/services/export/ExportService'

export default {
  namespaced: true,
  state: {
    exportsList: []
  },
  getters: {
    exportsList: state => state.exportsList
  },
  actions: {
    refreshExports ({ commit }) {
      return ExportsService.getAllExports()
        .then(list => {
          commit('SET_EXPORTS', list)
        })
    }
  },
  mutations: {
    SET_EXPORTS (state, list) {
      state.exportsList = list
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/export/exports.js